import { render, staticRenderFns } from "./HonjoFileLink.vue?vue&type=template&id=6f940e5b"
import script from "./HonjoFileLink.vue?vue&type=script&lang=ts"
export * from "./HonjoFileLink.vue?vue&type=script&lang=ts"
import style0 from "./HonjoFileLink.vue?vue&type=style&index=0&id=6f940e5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports